import main from '@/data/main.js'
export default class JobCategoryService {
    private base_url = `${main.BASE_ENDPOINT}/job_category`

    public async getAllJobCategories() {
        const uri = this.base_url
        const rawResponse = await fetch(uri,  {method: 'GET'})
        const response = await rawResponse.json()
        return response
    }
}